(function() {
  function init() {
    document.querySelectorAll('product-info').forEach(function(productInfo) {
      const dataScript = productInfo.querySelector('script[id^="en-variant-data-"]');
      if (!dataScript) return;

      let variantData = {};
      try {
        variantData = JSON.parse(dataScript.textContent);
      } catch(e) { return; }

      if (Object.keys(variantData).length === 0) return;

      const galleryEl = productInfo.querySelector('.product__media-list');
      if (!galleryEl) return;

      function applyVariantImage(variantId) {
        const src = variantData[String(variantId)];
        if (!src) return;
        const firstSlide = galleryEl.querySelector('.product__media-item');
        if (!firstSlide) return;
        const img = firstSlide.querySelector('img');
        if (img) img.src = src;
      }

      productInfo.addEventListener('change', function(e) {
        if (!e.target.matches('select[name="id"], input[name="id"]')) return;
        setTimeout(function() { applyVariantImage(e.target.value); }, 300);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();